export default class QueryWhereRightBracket
{
	remoteClass = "gongqi.erp.gotmodel.query.QueryWhereRightBracket";

	static None = "None";
	static Bracket1 = "Bracket1";
	static Bracket2 = "Bracket2";
	static Bracket3 = "Bracket3";
	static Bracket4 = "Bracket4";
	
	static valueOf(value)
	{
		if(value == "None")
			return QueryWhereRightBracket.None;
		else if(value == ")")
			return QueryWhereRightBracket.Bracket1;
		else if(value == "))")
			return QueryWhereRightBracket.Bracket2;
		else if(value == ")))")
			return QueryWhereRightBracket.Bracket3;
		else if(value == "))))")
			return QueryWhereRightBracket.Bracket4;
		
		throw new Error("错误的枚举类型");
	}
	
	static labelOf(value)
	{
		if(value == QueryWhereRightBracket.None || value == null)
			return "None";
		else if(value == QueryWhereRightBracket.Bracket1)
			return ")";
		else if(value == QueryWhereRightBracket.Bracket2)
			return "))";
		else if(value == QueryWhereRightBracket.Bracket3)
			return ")))";
		else if(value == QueryWhereRightBracket.Bracket4)
			return "))))";
		
		throw new Error("错误的枚举类型");
	}
	
}


// WEBPACK FOOTER //
// ./src/query/remote/QueryWhereRightBracket.js